import { getDb } from '../LocalDB/LocalDB';
import { injectReleasesToDeferrals } from './injectReleasesToDeferrals';
import { type SquawkAndDeferrals } from './types';

export async function getSquawksForAircraft(aircraftId: string): Promise<SquawkAndDeferrals[]> {
    const db = getDb();
    const squawks = await db.squawks.where({ aircraftId }).sortBy('createdAt');
    const squawkIds = squawks.map((s) => s.id);
    const [deferrals, releases] = await Promise.all([
        db.squawkDeferrals.where('squawkId').anyOf(squawkIds).sortBy('createdAt'),
        db.releaseToServices.where('squawkId').anyOf(squawkIds).toArray(),
    ]);
    const deferralsAndReleases = injectReleasesToDeferrals(deferrals, releases);
    return squawks.map((squawk): SquawkAndDeferrals => {
        return {
            ...squawk,
            deferrals: deferralsAndReleases.filter((d) => d.squawkId === squawk.id && !d.deleted),
            releases: releases.filter((r) => r.squawkId === squawk.id && r.deferralId === null),
        };
    });
}
